module.exports = __webpack_public_path__ + "img/IMG_1899_FoamcoreMatted.ec62a41e.jpg";